import { env } from '@common/env';

export const feedback = {
  open: () =>
    (window as any).appzi && (window as any).appzi.openWidget(env('APPZI_KEY')),
  close: () =>
    (window as any).appzi &&
    (window as any).appzi.dismissWidget(env('APPZI_KEY'))
};
